<template>
    <div class="grid grid-cols-12 gap-6">
        <div class="col-span-12 text-left md:col-span-12">
            <!-- <h2 class="mb-5">Abecední seznam ulic</h2> -->
            <div
                id="abeceda"
                class=""
            >
                <div
                    id="alphabet"
                    class="mb-4 flex flex-wrap justify-center"
                >
                    <div class="flex flex-wrap justify-center">
                        <button
                            id="letter-0-9"
                            @click="filterByLetter('0-9')"
                        >
                            0 - 9
                        </button>
                        <button
                            id="letter-a"
                            @click="filterByLetter('A')"
                        >
                            A
                        </button>
                        <button
                            id="letter-b"
                            @click="filterByLetter('B')"
                        >
                            B
                        </button>
                        <button
                            id="letter-c"
                            @click="filterByLetter('C')"
                        >
                            C
                        </button>
                        <button
                            id="letter-d"
                            @click="filterByLetter('D')"
                        >
                            D
                        </button>

                        <button
                            id="letter-e"
                            @click="filterByLetter('E')"
                        >
                            E
                        </button>
                        <button
                            id="letter-f"
                            @click="filterByLetter('F')"
                        >
                            F
                        </button>
                        <button
                            id="letter-g"
                            @click="filterByLetter('G')"
                        >
                            G
                        </button>
                        <button
                            id="letter-h"
                            @click="filterByLetter('H')"
                        >
                            H
                        </button>
                        <button
                            id="letter-ch"
                            @click="filterByLetter('Ch')"
                        >
                            Ch
                        </button>
                        <button
                            id="letter-i"
                            @click="filterByLetter('I')"
                        >
                            I
                        </button>
                        <button
                            id="letter-j"
                            @click="filterByLetter('J')"
                        >
                            J
                        </button>
                        <button
                            id="letter-k"
                            @click="filterByLetter('K')"
                        >
                            K
                        </button>
                        <button
                            id="letter-l"
                            @click="filterByLetter('L')"
                        >
                            L
                        </button>
                        <button
                            id="letter-m"
                            @click="filterByLetter('M')"
                        >
                            M
                        </button>
                        <button
                            id="letter-n"
                            @click="filterByLetter('N')"
                        >
                            N
                        </button>
                        <button
                            id="letter-o"
                            @click="filterByLetter('O')"
                        >
                            O
                        </button>
                        <button
                            id="letter-p"
                            @click="filterByLetter('P')"
                        >
                            P
                        </button>
                        <button
                            id="letter-r"
                            @click="filterByLetter('R')"
                        >
                            R
                        </button>
                        <button
                            id="letter-s"
                            @click="filterByLetter('S')"
                        >
                            S
                        </button>
                        <button
                            id="letter-t"
                            @click="filterByLetter('T')"
                        >
                            T
                        </button>
                        <button
                            id="letter-u"
                            @click="filterByLetter('U')"
                        >
                            U
                        </button>

                        <button
                            id="letter-v"
                            @click="filterByLetter('V')"
                        >
                            V
                        </button>
                        <button
                            id="letter-w"
                            @click="filterByLetter('W')"
                        >
                            W
                        </button>
                        <button
                            id="letter-x"
                            @click="filterByLetter('X')"
                        >
                            X
                        </button>

                        <button
                            id="letter-z"
                            @click="filterByLetter('Z')"
                        >
                            Z
                        </button>
                        <div
                            v-if="store.resultAbecedniSeznamUlic"
                            id="letter-close"
                            class="text-#FDF0F0 ml-10 h-auto cursor-pointer rounded border-1 px-1 py-1 hover:bg-black hover:text-white"
                            title="Zrušit filtr"
                            @click="filterClose()"
                        >
                            x
                        </div>
                    </div>
                </div>

                <div class="mb-3 flex justify-start bg-gray-50">
                    <div class="w-[50%] px-0 sm:px-[16px]">
                        <span class="mr-2 font-bold">Název ulice</span>
                        <UInput
                            id="nazev-ulice-filter"
                            :model-value="
                                table?.tableApi
                                    ?.getColumn('nazev-ulice')
                                    ?.getFilterValue() as string
                            "
                            class="max-w-sm"
                            placeholder=""
                            @update:model-value="
                                event => {
                                    table?.tableApi
                                        ?.getColumn('nazev-ulice')
                                        ?.setFilterValue(event)
                                    // Update responseDataFilterLength after filtering
                                    responseDataFilterLength =
                                        table?.tableApi?.getFilteredRowModel()
                                            .rows.length || 0
                                    // Move to first page after filtering
                                    if (firstPageBtn)
                                        (
                                            firstPageBtn as HTMLButtonElement
                                        ).click()
                                }
                            "
                        />
                    </div>

                    <div class="px-[16px]">
                        <span class="mr-2 font-bold">Katastr</span>
                        <UInput
                            id="katastr-filter"
                            :model-value="
                                table?.tableApi
                                    ?.getColumn('katastr')
                                    ?.getFilterValue() as string
                            "
                            class="max-w-sm"
                            placeholder=""
                            @update:model-value="
                                event => {
                                    table?.tableApi
                                        ?.getColumn('katastr')
                                        ?.setFilterValue(event)
                                    // Update responseDataFilterLength after filtering
                                    responseDataFilterLength =
                                        table?.tableApi?.getFilteredRowModel()
                                            .rows.length || 0
                                    // Move to first page after filtering
                                    if (firstPageBtn)
                                        (
                                            firstPageBtn as HTMLButtonElement
                                        ).click()
                                }
                            "
                        />
                    </div>
                </div>

                <div
                    v-if="
                        !responseDataFilter.length &&
                        !store.resultAbecedniSeznamUlic
                    "
                    class="flex items-center justify-center py-10"
                >
                    <svg
                        class="h-8 w-8 animate-spin text-gray-400"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                    >
                        <circle
                            class="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            stroke-width="4"
                        />
                        <path
                            class="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                        />
                    </svg>
                </div>
                <div
                    v-if="
                        responseDataFilter.length === 0 &&
                        store.resultAbecedniSeznamUlic
                    "
                    class="flex items-center justify-center py-10 text-gray-500"
                >
                    Žádné výsledky nenalezeny.
                </div>
                <UTable
                    v-if="store.streetsAll.length > 0"
                    ref="table"
                    v-model:pagination="pagination"
                    :data="responseDataFilter"
                    :columns="columns"
                    :pagination-options="{
                        getPaginationRowModel: getPaginationRowModel(),
                    }"
                    @click="selectStreet($event)"
                />

                <div class="mt-2 mb-2 flex justify-center text-black">
                    <span v-if="store.streetsAll.length > 0">
                        {{ responseDataFilterLength }} nalezených ulic
                    </span>
                    <span v-else>
                        <span v-if="responseDataFilterLength === 3">
                            {{ responseDataFilterLength }} nalezené ulice
                        </span>
                        <span v-else
                            >{{ responseDataFilterLength }} nalezených
                            ulic</span
                        >
                    </span>
                </div>

                <div
                    class="border-default mb-10 flex justify-center border-t pt-4"
                >
                    <UPagination
                        :default-page="
                            (table?.tableApi?.getState().pagination.pageIndex ||
                                0) + 1
                        "
                        :items-per-page="
                            table?.tableApi?.getState().pagination.pageSize
                        "
                        :total="
                            table?.tableApi?.getFilteredRowModel().rows.length
                        "
                        @update:page="p => table?.tableApi?.setPageIndex(p - 1)"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { getPaginationRowModel } from "@tanstack/vue-table"
import type { TableColumn } from "@nuxt/ui"

const table = useTemplateRef("table")

//const { serverUri } = useDataLogic()

const router = useRouter()

const store = useMainStore()

const responseData = ref<any>([])

const responseDataFilter = ref<any>([])

const responseDataFilterLength = ref(0)

const firstPageBtn = ref<HTMLButtonElement | null>(null)
onMounted(() => {
    firstPageBtn.value = document.querySelector(
        "button[aria-label='First Page']"
    )
})

//onMounted
// onMounted(async () => {
//     await CreateAbecedniSeznamUlic()
// })

//async function CreateAbecedniSeznamUlic() {
// store.resultAbecedniSeznamUlic = false
// const data = await $fetch<any[]>("select-heslo-all", {
//     baseURL: serverUri(),
// })

// Watch for loading state
watch(
    () => store.streetsAll,
    newVal => {
        if (Array.isArray(newVal) && newVal.length > 0) {
            store.resultAbecedniSeznamUlic = false

            responseData.value = newVal
            responseDataFilter.value = newVal
            responseDataFilterLength.value = responseDataFilter.value.length
        }
    },
    { immediate: true }
)

function selectStreet(event: MouseEvent) {
    const target = event.target as HTMLElement
    const tableRow = target.parentElement?.children[0] as HTMLElement
    // Assuming the first child is the street name

    // console.log("Selected street:", tableRow.textContent)

    router.push({ name: "detail", query: { id: tableRow.textContent } })
    //results.value = []
}

type List = {
    id: string
    nazevUlice: string
    katastr: string
}

const columns: TableColumn<List>[] = [
    {
        accessorKey: "_id",
        header: "ID",
    },
    {
        accessorKey: "nazev-ulice",
        header: "Název ulice",
    },
    {
        accessorKey: "katastr",
        header: "Katastr",
    },
]

const pagination = ref({
    pageIndex: 0,
    pageSize: 10,
})

const filterByLetter = (letter: string) => {
    store.resultAbecedniSeznamUlic = false

    // Reset the active letter
    document
        .querySelectorAll("#alphabet button")
        .forEach(btn => btn.classList.remove("active"))
    const clickedBtn = document.getElementById(`letter-${letter.toLowerCase()}`)
    if (clickedBtn) clickedBtn.classList.add("active")

    responseDataFilter.value = responseData.value.filter((item: any) => {
        if (letter === "0-9") {
            store.resultAbecedniSeznamUlic = true
            return /^[0-9]/.test(item["nazev-ulice"])
        }
        if (letter === "C") {
            store.resultAbecedniSeznamUlic = true
            return (
                item["nazev-ulice"].startsWith("C") ||
                item["nazev-ulice"].startsWith("Č")
            )
        }
        if (letter === "D") {
            store.resultAbecedniSeznamUlic = true
            return (
                item["nazev-ulice"].startsWith("D") ||
                item["nazev-ulice"].startsWith("Ď")
            )
        }
        if (letter === "U") {
            store.resultAbecedniSeznamUlic = true
            return (
                item["nazev-ulice"].startsWith("U") ||
                item["nazev-ulice"].startsWith("Ú")
            )
        }
        if (letter === "Z") {
            store.resultAbecedniSeznamUlic = true
            return (
                item["nazev-ulice"].startsWith("Z") ||
                item["nazev-ulice"].startsWith("Ž")
            )
        }
        store.resultAbecedniSeznamUlic = true
        return item["nazev-ulice"].startsWith(letter)
    })

    // Nastav stránkovanie na prvú stranu (aj vizuálne na UPagination)
    // const firstPageBtn = document.querySelector(
    //     "button[aria-label='First Page']"
    // )
    if (firstPageBtn.value) (firstPageBtn.value as HTMLButtonElement).click()

    // Kontrola aktívnych filtrov podľa názvu ulice alebo katastru
    const nazevUliceFilter = table.value?.tableApi
        ?.getColumn("nazev-ulice")
        ?.getFilterValue()
    const katastrFilter = table.value?.tableApi
        ?.getColumn("katastr")
        ?.getFilterValue()

    if (nazevUliceFilter || katastrFilter) {
        // Aktualizuj délku podle filtrovaných řádků v tabulce, ale len tie, ktoré sú aj vo responseDataFilter
        const filteredRows =
            table.value?.tableApi?.getFilteredRowModel().rows || []
        responseDataFilterLength.value = filteredRows.filter(row =>
            responseDataFilter.value.some(item => item._id === row.original._id)
        ).length
    } else {
        responseDataFilterLength.value = responseDataFilter.value.length
    }
}

const filterClose = () => {
    // Reset the filter
    store.resultAbecedniSeznamUlic = false

    // Reset the active letter
    document
        .querySelectorAll("#alphabet button")
        .forEach(btn => btn.classList.remove("active"))

    responseDataFilter.value = responseData.value
    responseDataFilterLength.value = responseDataFilter.value.length

    // Nastav stránkovanie na prvú stranu (aj vizuálne na UPagination)
    // const firstPageBtn = document.querySelector(
    //     "button[aria-label='First Page']"
    // )
    if (firstPageBtn.value) (firstPageBtn.value as HTMLButtonElement).click()
}
</script>
